import React from 'react'

const NiveauEtude = ({ handleChange, values, niveauxEtude, handleErreur }) => {

    const getNiveauEtude = () => {
        return niveauxEtude?.map((niveau) => {
            return <option value={niveau.id}>{niveau.libelle}
            </option>;
        });
    }
    const getEtat = () => {
        return values.etudeInformatique ? "checked" : "";
    }
    if (values.idSituation == "121151") {
        return (
            <div class="d-flex niveauEtude">
                <div class="col-sm-6 mt-sm-0 mt-4 d-flex flex-column niveauEtudeChoix">
                    <label>Quel est votre niveau d'études ?*</label>
                    <select
                        type="text"
                        value={values.idNiveauEtude}
                        onChange={handleChange("idNiveauEtude")}
                        id="idNiveauEtude"
                    >
                        <option value="0" selected="selected"></option>
                        {getNiveauEtude()}
                    </select>
                    {handleErreur('idNiveauEtude')}
                </div>
                <div class="col-sm-6 mt-4">
                    <input type="checkbox" checked={getEtat()} onChange={handleChange("etudeInformatique")} />
                    <label class="mx-custom-10">Etudes en informatique ?</label>
                </div>
            </div>
        )
    } else {
        return <></>
    }
}

export default NiveauEtude